import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const SurveyPicker = lazy(() =>
  import(/* webpackChunkName: "SurveyPicker" */ '../../components/survey_explorer/LoadSurveyPicker')
);

export default function SurveyPickerComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <SurveyPicker {...props} />
    </Suspense>
  );
}
